// Pagina Cantina (snippets/wm-cantina-dossier.liquid): galleria a miniature e
// troncamento della descrizione. Entrambe le guardie sono implicite nei
// querySelectorAll: su pagine senza dossier questo blocco non fa nulla.
document.addEventListener('DOMContentLoaded', function () {
  // --- galleria: la miniatura cliccata diventa l'immagine principale e prende
  // lo stato attivo, che viene tolto alle altre miniature della STESSA galleria
  // (non di tutta la pagina: la pagina potrebbe ospitarne più di una).
  document.querySelectorAll('.wm-cantina-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var galleria = thumb.closest('.wm-cantina-gallery');
      if (!galleria) return;

      var main = galleria.querySelector('.wm-cantina-gallery__main');
      if (main && thumb.dataset.full) main.src = thumb.dataset.full;

      galleria.querySelectorAll('.wm-cantina-gallery__thumb').forEach(function (altra) {
        altra.classList.remove('is-active');
        altra.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
    });
  });

  // --- descrizione: il markup arriva già troncato (classe .is-collapsed, solo
  // CSS). Qui si misura se il testo eccede davvero il limite: se sì compaiono
  // sfumatura e bottone, altrimenti il troncamento viene rimosso — su una
  // descrizione corta non devono restare né bottone né sfumatura.
  document.querySelectorAll('[data-wm-desc]').forEach(function (blocco) {
    var testo = blocco.querySelector('.wm-cantina-desc__text');
    var toggle = blocco.querySelector('.wm-cantina-desc__more');
    if (!testo || !toggle) return;

    var ETICHETTE = { chiuso: 'Continua a leggere →', aperto: 'Riduci ↑' };
    var toccatoDaUtente = false;

    function misura() {
      if (toccatoDaUtente || !testo.classList.contains('is-collapsed')) return;
      // +2px di tolleranza: gli arrotondamenti sub-pixel di line-height possono
      // dare scrollHeight maggiore di 1px anche senza overflow reale.
      if (testo.scrollHeight > testo.clientHeight + 2) {
        testo.classList.add('is-truncated');
        toggle.hidden = false;
      } else {
        testo.classList.remove('is-collapsed', 'is-truncated');
        toggle.hidden = true;
      }
    }

    toggle.addEventListener('click', function () {
      toccatoDaUtente = true;
      var espandi = testo.classList.contains('is-collapsed');
      testo.classList.toggle('is-collapsed', !espandi);
      testo.classList.toggle('is-truncated', !espandi);
      toggle.setAttribute('aria-expanded', espandi ? 'true' : 'false');
      toggle.textContent = espandi ? ETICHETTE.aperto : ETICHETTE.chiuso;
    });

    misura();
    // Seconda misura a font/immagini caricati: il web font cambia l'altezza
    // reale del testo e può ribaltare l'esito della prima misura.
    window.addEventListener('load', misura);
  });
});

(function () {
  var STORAGE_KEY = 'wm_cantine_salvate';

  function leggiSalvate() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function scriviSalvate(lista) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(lista));
    } catch (e) {
      // Storage disabilitato/pieno (es. Safari private mode, quota superata):
      // non blocchiamo l'interazione, il bottone resta comunque coerente
      // con lo stato in memoria per il resto della sessione.
    }
  }

  function aggiornaBottone(btn) {
    var salvate = leggiSalvate();
    var salvata = salvate.some(function (c) { return c.handle === btn.dataset.handle; });
    btn.setAttribute('aria-pressed', salvata ? 'true' : 'false');
    btn.textContent = salvata ? '♥ NEL TACCUINO' : '♡ SALVA NEL TACCUINO';
  }

  document.querySelectorAll('[data-wm-save-cantina]').forEach(function (btn) {
    aggiornaBottone(btn);
    btn.addEventListener('click', function () {
      var salvate = leggiSalvate();
      var idx = salvate.findIndex(function (c) { return c.handle === btn.dataset.handle; });
      if (idx > -1) {
        salvate.splice(idx, 1);
      } else {
        salvate.push({ handle: btn.dataset.handle, titolo: btn.dataset.titolo, regione: btn.dataset.regione });
      }
      scriviSalvate(salvate);
      aggiornaBottone(btn);
    });
  });

  var lista = document.getElementById('wm-vignaioli-salvati');
  if (lista) {
    var salvate = leggiSalvate();
    // Nodi costruiti via createElement/textContent (non innerHTML con
    // string-concat): titolo e regione arrivano da dati salvati dall'utente
    // in localStorage e potrebbero contenere '&', '<', '"' — textContent
    // li tratta sempre come testo puro, mai come markup.
    while (lista.firstChild) {
      lista.removeChild(lista.firstChild);
    }
    if (salvate.length === 0) {
      var vuoto = document.createElement('p');
      vuoto.className = 'wm-coord';
      vuoto.textContent = 'Nessun vignaiolo salvato ancora.';
      lista.appendChild(vuoto);
    } else {
      salvate.forEach(function (c) {
        var link = document.createElement('a');
        link.className = 'wm-card';
        link.style.display = 'inline-block';
        link.style.padding = '8px 12px';
        link.style.margin = '0 8px 8px 0';
        link.style.textDecoration = 'none';
        link.style.color = 'inherit';
        link.href = '/pages/cantina/' + encodeURIComponent(c.handle);

        var tag = document.createElement('div');
        tag.className = 'wm-card__tag';
        tag.textContent = c.regione;

        var titolo = document.createElement('div');
        titolo.className = 'wm-card__title';
        titolo.textContent = c.titolo;

        link.appendChild(tag);
        link.appendChild(titolo);
        lista.appendChild(link);
      });
    }
  }
})();

// Carosello hero (Task 1 restyling Esploratore) — porting 1:1 da src-home.html
// righe ~844-865. Guardia esplicita: su pagine senza sezione hero non fa nulla.
(function () {
  if (!document.querySelector('.hero-slide')) return;

  var slides = Array.prototype.slice.call(document.querySelectorAll('.hero-slide'));
  var dots = Array.prototype.slice.call(document.querySelectorAll('.hero-dot'));
  var heroSection = document.querySelector('.hero');
  var autoplayEnabled = !heroSection || heroSection.dataset.autoplay !== 'false';
  var heroTimer;

  function showSlide(i) {
    slides.forEach(function (s, idx) { s.classList.toggle('active', idx === i); });
    dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
  }

  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      showSlide(Number(d.dataset.dot));
      clearInterval(heroTimer);
      if (autoplayEnabled) startHeroAuto();
    });
  });

  function startHeroAuto() {
    heroTimer = setInterval(function () {
      var current = slides.findIndex(function (s) { return s.classList.contains('active'); });
      showSlide((current + 1) % slides.length);
    }, 6000);
  }

  // L'avanzamento parte alla prima interazione dell'utente (dopo il load): se la
  // seconda slide (lazy) compare mentre la pagina sta ancora caricando diventa lei
  // l'elemento LCP e il tempo misurato si allunga di molti secondi. Il browser
  // chiude la misura dell'LCP proprio alla prima interazione.
  if (autoplayEnabled) {
    var armed = false;
    var arm = function () {
      if (armed) return;
      armed = true;
      ['pointerdown', 'keydown', 'scroll', 'mousemove', 'touchstart'].forEach(function (ev) {
        window.removeEventListener(ev, arm);
      });
      startHeroAuto();
    };
    ['pointerdown', 'keydown', 'scroll', 'mousemove', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, arm, { passive: true });
    });
  }
})();

// Carosello prodotto — sezione riusabile "Collezione prodotti" (Task 5
// restyling Esploratore), porting 1:1 da src-home.html righe ~883-890.
// Guardia esplicita su '.carousel-arrow': su pagine/sezioni senza carosello
// (es. istanze in layout griglia) non fa nulla. A differenza del mockup
// (id fisso 'track-nuovi-arrivi'/'track-champagne'), ogni istanza qui è
// scopata su un id derivato da section.id — la sezione è riusabile più
// volte nella stessa pagina, un id fisso collisionerebbe tra le istanze.
(function () {
  var arrows = document.querySelectorAll('.carousel-arrow');
  if (!arrows.length) return;

  arrows.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var track = document.getElementById(btn.dataset.carouselTarget);
      if (!track) return;
      var amount = track.clientWidth * 0.85 * Number(btn.dataset.dir);
      track.scrollBy({ left: amount, behavior: 'smooth' });
    });
  });
})();

// Rimozione widget Trustpilot iniettato via script esterno dell'app (JS injection
// verso ecommplugins-scripts.trustpilot.com), non presente in nessun file di questo
// tema. La configurazione server-side dell'app punta a una sezione di un tema
// precedente ormai inesistente e ricade su un fallback posizionale che oggi atterra
// dentro sezioni di QUESTO tema (osservato in home, ma la config app potrebbe
// posizionarlo diversamente su altre pagine) — richiesta esplicita del cliente:
// rimuoverlo solo da questo tema, senza toccare l'app/Script Tag a livello di
// negozio (che riguarderebbe anche il tema attualmente live).
// Selettore generico (non legato alla sezione in cui è atterrato oggi): il nodo
// radice del widget ha id="trustpilot-widget-trustbox-N" e class="trustpilot-widget".
// Rimozione reale dal DOM (.remove(), non display:none): l'obiettivo è che lo script
// Trustpilot non lasci comunque un iframe/richieste caricate in pagina.
(function () {
  var SELECTOR = '[id^="trustpilot-widget-trustbox"], .trustpilot-widget';
  var OBSERVE_MS = 15000; // finestra ragionevole per intercettare inserimenti async;
  // oltre non serve tenere l'observer attivo per sempre — lo script esterno inserisce
  // il widget entro pochi secondi dal load, non ricompare più dopo.

  function isEmptyWrapper(el) {
    // "Vuoto" = nessun elemento figlio residuo e nessun testo visibile (solo
    // spazi/newline). Evita di rimuovere contenitori che contengono altro markup
    // del tema oltre al widget.
    return el.children.length === 0 && el.textContent.trim() === '';
  }

  function rimuoviWidgetTrustpilot() {
    document.querySelectorAll(SELECTOR).forEach(function (nodo) {
      if (!nodo.isConnected) return; // già rimosso in un giro precedente
      var parent = nodo.parentElement;
      nodo.remove();
      // Rimuove anche il wrapper genitore (es. id="...-wrapper") se resta vuoto:
      // altrimenti resterebbe un contenitore fantasma con margini/padding residui
      // che romperebbe il layout della sezione dove il widget è atterrato.
      if (parent && parent !== document.body && isEmptyWrapper(parent)) {
        parent.remove();
      }
    });
  }

  rimuoviWidgetTrustpilot(); // nel caso il widget sia già presente prima dell'observer

  var observer = new MutationObserver(rimuoviWidgetTrustpilot);
  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(function () {
    observer.disconnect();
  }, OBSERVE_MS);
})();
